import { useCollaborationColors } from "@hooks/useCollaborationColors"

import { Tooltip } from "@atoms"

import UserAvatar from "@molecules/UserAvatar/UserAvatar"

import type { EditingUserAvatarProps } from "./EditingUserAvatar.types"

export default function EditingUserAvatar(props: EditingUserAvatarProps) {
    const { user, size, actionLabel = "editing" } = props

    const { getUserColor } = useCollaborationColors()
    const liveRingColor = getUserColor(String(user.id)) ?? undefined
    const displayName = user.short_name || user.full_name

    return (
        <Tooltip body={`${displayName} is ${actionLabel}...`}>
            <UserAvatar user={user} size={size} isLive={true} liveRingColor={liveRingColor} />
        </Tooltip>
    )
}
